import React from 'react'
import BootstrapModal from 'react-bootstrap/Modal'
import Button from '../Elements/Button'
import { useTranslation } from 'react-i18next'

type PropsType = {
    show: boolean
    handleClose: () => void
    onSuccess?: () => void
    title: string
    body: React.ReactNode
    defaultFooter?: boolean
    hideCloseIcon?: boolean
    customWidth?: boolean
}

const Modal = ({
    show,
    handleClose,
    onSuccess,
    title,
    body,
    defaultFooter,
    hideCloseIcon,
    customWidth,
}: PropsType) => {
    const { t } = useTranslation()
    return (
        <>
            <BootstrapModal
                centered
                show={show}
                onHide={!hideCloseIcon ? handleClose : undefined}
                className={customWidth ? 'customwdt' : ''}
            >
                <BootstrapModal.Header
                    closeButton={!hideCloseIcon ? true : false}
                >
                    <BootstrapModal.Title>{title}</BootstrapModal.Title>
                </BootstrapModal.Header>
                <BootstrapModal.Body>{body}</BootstrapModal.Body>
                {defaultFooter && (
                    <BootstrapModal.Footer>
                        <div className="row">
                            <div className="col-6">
                                <Button variant="primary" onClick={handleClose}>
                                    {t('button.no')}
                                </Button>
                            </div>
                            <div className="col-6">
                                <Button variant="primary" onClick={onSuccess}>
                                    Yes
                                </Button>
                            </div>
                        </div>
                    </BootstrapModal.Footer>
                )}
            </BootstrapModal>
        </>
    )
}

export default Modal
